import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpTranslateLoaderFactory(http: HttpClient) {
    // return new TranslateHttpLoader(http, 'localhost:40' + '/editaware/' , '.json');
    return new TranslateHttpLoader(http);
  }
